module.exports = __webpack_public_path__ + "static/media/interactive_image_icon--active.5230e224.svg";